/**
 * Input - H5 版本，使用 zarm Input
 * onChange 统一为 (value: string) => void
 */
import React from 'react';
import { Input as ZarmInput } from 'zarm-v3';
import { IsomorphicInputProps } from './type';

export const Input: React.FC<IsomorphicInputProps> = ({ onChange, ...props }) => (
  <ZarmInput
    {...props}
    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value)}
  />
);

export default Input;
